import * as React from "react";
import { Actions, AppState, store, IPageState } from '../../appredux';
import { connect } from 'react-redux';
import { Button, FormControl, Grid, Theme, Typography, withStyles, WithStyles } from '@material-ui/core';
import SzczegolyTabela from "./SzczegolyTabela";
import { SerwisService,  Result, FakturaVatService, VatTableRow, VatHeder, VatTableRowFromTo } from "../../api";
import { sortujAdresyIp, weekDay } from "../common/helpers";

import Ladowanie, {NoResult} from "./Ladowanie";
import Pagination, { calculateRange } from "./Pagination";
import CONFIG from "../../cfg/config";

import TodayIcon from '@mui/icons-material/Today';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import PhoneIcon from '@mui/icons-material/Phone';

interface StatusProps extends WithStyles<typeof styles> {
    page: IPageState,

    width: number,
    status: VatTableRowFromTo,

    serwisStatusTablica: VatTableRow[],
    setSerwisStatusTablica: (tab: VatTableRow[]) => void,

    serwisStatusIlosc: number,
    setSerwisStatusIlosc: (ilosc: number) => void,

    paginacjaStatus: number[],
    setPaginacjaStatus: (paginacja: number[]) => void,
}

interface StatusState {
    ladowanie: boolean,
    naglowek: VatHeder,
}

class Status extends React.Component<StatusProps, StatusState>  {
    constructor(props: StatusProps) {
        super(props, {});
        this.state = {
            ladowanie: this.props.serwisStatusTablica.length === 0 ? true : false,
            naglowek: new VatHeder()
        }
    }

    //PM 2021-10-25
    //podlaczenie do API
    async componentDidMount() {
        //if(this.props.load){
            await this.dajSerwisKtoIlosc();
            this.props.setPaginacjaStatus([0, 1, this.props.paginacjaStatus[2]])
            await this.dajSerwisKto( 1, this.props.paginacjaStatus[2]);
        //}   
    }

    // async componentDidUpdate(prevProps: StatusProps) {
    //     if(this.props.refresh !== prevProps.refresh) {
    //         await this.dajSerwisKtoIlosc()
    //         await this.dajSerwisKto(this.props.paginacjaStatus[0] + 1, this.props.paginacjaStatus[0] + this.props.paginacjaStatus[2]);
    //     }
    // }

    dajSerwisKtoIlosc = async () => {
        try {
            //this.setState({ ladowanie: true })

            //const serwisKtoIlosc = await SerwisService.dajSerwisKtoIlosc({ hotelId: this.props.hotelId })

            //this.props.setSerwisStatusIlosc(1);
            //this.setState({ ladowanie: false })
        } catch (error) {
            console.log(error);
        }
    }

    //PM 2021-10-25
    dajSerwisKto = async (start: number = 1, end: number = 10) => {
        try {
            this.setState({ ladowanie: true })

            let [res1, res2] = await Promise.all(
                [
                    FakturaVatService.getHeader({
                        hotelId: CONFIG.hotelID,
                        dokNr: this.props.status.dokNr
                    }, {}),
                    FakturaVatService.getTableRows({
                        hotelId: CONFIG.hotelID,
                        dokNr: this.props.status.dokNr
                    }, {}),
                ]);
      
            if(res1.result && res2.result  ){
                this.setState({naglowek: res1.result[0]})
                this.props.setSerwisStatusIlosc(res2.result.length);
                this.props.setSerwisStatusTablica(res2.result)
            } else {
                throw "Nie pobrano wszystkich danych do faktury.";
            }

            this.setState({ladowanie: false})
            
          
        } catch (error) {
            console.log(error);
        }
    }

    
    // setRodzajSortowania = async (rodzaj: string) => {
    //     await store.dispatch(Actions.pageState.setZakladkaStatus(rodzaj));
    //     this.dajSerwisKto(1, this.props.paginacjaStatus[2])
    // }

    updateSkip = async (aPage: number) => {
        const newSkip = (aPage - 1) * this.props.paginacjaStatus[2]

        this.props.setPaginacjaStatus([newSkip, aPage, this.props.paginacjaStatus[2]])
        this.dajSerwisKto(newSkip +1, newSkip + this.props.paginacjaStatus[2])
    }

    changeRowsPerPage = async (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
        //await store.dispatch(Actions.pageState.setPaginacjaStatus([0, 1, this.props.paginacjaStatus[2]]));
        this.props.setPaginacjaStatus([0, 1, Number(event.target.value)])
        this.dajSerwisKto(1, Number(event.target.value))
    }

    //PM 2021-10-25
    //podlaczenie do API
    render = () => {
        const classes = this.props.classes;
        const range = calculateRange(this.props.serwisStatusIlosc, this.props.paginacjaStatus[2])

        return (
            <div className={classes.container} style={{ width: '100%' }}>
                <Typography variant="h6" component="h2" color="primary" align="center" style={{paddingBottom: "20px", fontSize: "1.25rem"}}>
                    {/* <b>{this.props.serwisStatusTablica.length ? ('kto ' + this.props.serwisStatusTablica[0].hotelId) : ''}</b> */}
                    {/* <b>{'SZCZEGÓŁY ZAMÓWIENIA'}</b> */}
                    {/* <b>{`${this.props.status.data} | ${this.props.status.kwota} | ${this.props.status.za}`}</b> */}
                    <b>{this.state.naglowek.dokNr === "" ? "" : 
                    <>
                    <span>{this.state.naglowek.dokNr}</span>
                    <span className={classes.blueDark}><TodayIcon className={classes.icon}/>{this.state.naglowek.dataSprz} {weekDay(this.state.naglowek.dataSprz)}</span>
                    <span className={classes.brownLight}><MonetizationOnOutlinedIcon className={classes.icon} />{this.state.naglowek.brutto}zł</span>
                    <PhoneIcon className={classes.icon} /><span>{this.state.naglowek.kontrNazwa} </span>
                    </>}</b>
                </Typography>
                {/* <FormControl component="fieldset" variant="outlined" fullWidth margin='normal' className={classes.fieldset}>
                    <Grid container direction="row" alignItems='center'>
                        {[
                            { value: '1', zakladka: 'Kto' },
                            { value: '3', zakladka: 'Awarie' },
                            { value: '4', zakladka: 'Zapisy' },
                            { value: '2', zakladka: 'Adres IP' },
                        ].map((z, index) => {
                            return (
                                <Grid key={z.value} item className={classes.gridButton}>
                                    <Button
                                        style={{ width: this.props.width > 800 && index !== 3 ? "calc(100% + -3px)" : "100%", padding: "14px 0px", whiteSpace: "pre" }}
                                        className={`${classes.input} ${this.props.zakladkaStatus === z.value ? classes.primaryBackground : classes.seagreen}`}
                                        variant="outlined" color="primary"
                                        onClick={async () => await this.setRodzajSortowania(z.value)}
                                    >
                                        {z.zakladka}
                                    </Button>
                                </Grid>
                            )
                        })}
                    </Grid>
                </FormControl> */}

                {this.state.ladowanie ?
                    <Ladowanie /> :
                    this.props.serwisStatusTablica.length ?
                        <>
                            <SzczegolyTabela tableBody={this.props.serwisStatusTablica} />
                            {/* <Pagination
                                page={this.props.paginacjaStatus[1]}
                                range={range}
                                updateSkip={this.updateSkip}
                                changeResultsPerPage={this.changeRowsPerPage}
                                resultsPerPage={this.props.paginacjaStatus[2]}
                                tableLength={this.props.serwisStatusIlosc}
                            /> */}
                        </> : <NoResult/>}
                 
            </div>
        )
    }
}

const styles = (theme: Theme) => ({
    gridButton: {
        width: 'calc((100% )/4)',
        "@media screen and (max-width: 800px)": {
            width: "100%"
        },
    },
    input: {
        border: "2px solid lavender",
        borderRadius: "0px",
        fontSize: "14px",
        lineHeight: "14px",
        fontWeight: "bold" as "bold",
        textTransform: "none" as "none",
        padding: "14px 0px",
        whiteSpace: "pre" as "pre",
        "&:hover": {
            border: "2px solid lavender",
            background: "#007000",
            color: 'white',
        },
    },
    primaryBackground: {
        color: "white",
        backgroundColor: theme.palette.primary.main,
    },
    seagreen: {
        color: 'seagreen',
    },
    fieldset: {
        marginBottom: '18px'
    },
    container: {
        margin: 'auto',
    },
    icon: {
        marginBottom: "-5px",
        paddingLeft: "15px",
        paddingRight: "5px"
    },
    green: {
        //color: 'rgba(69, 139, 0, 0.5)'
        color: 'rgba(40, 160, 0, 0.8)'
      },
      blueDark: {
        //color: 'rgba(0, 90, 126, 0.5)'
        color: 'rgba(0, 90, 126, 0.8)'
      },
      brownLight: {
        //color: 'rgba(191, 136, 85, 0.5)'
        color: 'rgba(191, 136, 85, 0.8)'
      },
});

// połączenie z Redux
const mapStateToProps = (state: AppState) => ({
    page: state.pageState,
});



export default connect(mapStateToProps)(withStyles(styles)(Status));
